const tr = {
  // brand
  siteName: "Emel Yıldırım",
  siteTagline: "Yazılım Mühendisi",

  // nav
  navHome: "Ana Sayfa",
  navBlog: "Yazılar",
  navProjects: "Projeler",
  navResume: "CV",
  navAbout: "Hakkımda",
  navContact: "İletişim",

  // hero
  heroTitle: "Kurumsal sistemler için yazılım geliştiriyorum.",
  heroLead:
    "Oracle PL/SQL, veri tabanı odaklı uygulamalar ve süreç yönetimi (CRM/Helpdesk) üzerinde; sürdürülebilir, ölçülebilir ve operasyonu rahatlatan çözümler üretiyorum.",
  heroCtaPrimary: "Yazıları Gör",
  heroCtaResume: "CV’yi Gör",
  heroCtaSecondary: "İletişime Geç",

  // profile / focus
  profileTitle: "Oracle PL/SQL & Kurumsal Uygulamalar",
  hlPlsql: "Oracle PL/SQL (19c) ile paket/prosedür geliştirme",
  hlEnterprise: "Kurumsal uygulamalarda analiz → geliştirme → bakım",
  hlCrm: "CRM, Helpdesk ve süreç yönetimi modülleri",
  hlData: "Veri tabanı modelleme ve iş kuralları entegrasyonu",
  hlWeb: "REST API ve web arayüzleri (React / temel Next.js)",
  hlDocs: "Teknik dokümantasyon ve kullanıcı eğitimi süreçleri",

  focusDbTitle: "Veri Tabanı & PL/SQL",
  focusDbDesc:
    "Performans, veri bütünlüğü ve okunabilirlik dengesini koruyan PL/SQL çözümleri.",
  focusEnterpriseTitle: "Süreç & Modül Geliştirme",
  focusEnterpriseDesc:
    "CRM/Helpdesk gibi operasyonel sistemlerde ekran + iş kuralı + raporlama bütünlüğü.",
  focusWebTitle: "Web & Entegrasyon",
  focusWebDesc:
    "RESTful servisler, dashboard’lar ve kullanıcı odaklı arayüzler.",

  // sections
  sectionFocus: "Odak Alanlarım",
  sectionLatestPosts: "Öne Çıkan Yazılar",
  sectionProjects: "Seçili Çalışmalar",
  sectionApproach: "Nasıl çalışırım?",
  sectionApproachLead:
    "İş ihtiyacı → süreç → teknik kararlar → ölçülebilir sonuç.",
  finalCtaTitle: "Birlikte çalışmak ister misiniz?",
  finalCtaLead:
    "Bir pozisyon, proje ya da danışmanlık ihtiyacı için iletişime geçebilirsiniz. Detaylı CV ve seçili çalışmalar sayfalarından ilerleyebiliriz.",

  trustBand: [
    { k: "Oracle & SQL", v: "Veri tabanı odaklı kurumsal çözümler" },
    { k: "Süreç", v: "CRM/Helpdesk ve operasyonel modüller" },
    { k: "Raporlama", v: "Dashboard, KPI ve görünürlük" },
    { k: "Uçtan uca", v: "Analiz → geliştirme → bakım" },
  ],

  approachSteps: [
    {
      title: "İhtiyacı dinlerim",
      desc: "Problemi ve kullanıcıyı netleştiririm.",
    },
    {
      title: "Süreci modelleyip sadeleştiririm",
      desc: "Darboğazları ortaya çıkarırım.",
    },
    {
      title: "Teknik yapıyı kurarım",
      desc: "Veri modeli + iş kuralı + performans.",
    },
    {
      title: "Kullanılabilir arayüz üretirim",
      desc: "Ekranlar gerçekten iş görür.",
    },
    {
      title: "İyileştirmeyi sürdürürüm",
      desc: "Bakım, rapor ve dokümantasyon.",
    },
  ],

  // blog
  blogTitle: "Yazılar",
  readMore: "Devamını Oku",
  backToPosts: "Tüm yazılara dön",
  minutes: "dk",
  filterAll: "Tümü",
  viewDetails: "Detayı Gör",
  backToProjects: "Projeler",
  projectSummary: "Proje özeti",
  projectProblem: "İş problemi",
  projectRole: "Benim rolüm",
  projectDecisions: "Öne çıkan kararlar",
  projectOutcome: "Sonuç / katkı",
  projectLearnings: "Öğrenimler",

  // about
  aboutTitle: "Hakkımda",
  aboutText:
    "Kurumsal yazılım projelerinde aktif rol alan, web/mobil/masaüstü geliştirme deneyimi bulunan Yazılım Mühendisiyim. Analizden canlıya, bakım ve dokümantasyona kadar uçtan uca sorumluluk almayı; veri tabanı odaklı düşünmeyi ve süreçleri operasyonel olarak iyileştirmeyi önemsiyorum.",

  // contact
  contactTitle: "İletişim",
  contactLead:
    "İş birliği, danışmanlık veya soru/öneri için e-posta üzerinden ulaşabilirsiniz.",
  contactEmailLabel: "E-posta",
  contactLinksLabel: "Linkler",
  contactAction: "E-posta Gönder",
  contactNote:
    "Not: Form EmailJS ile çalışır. Anahtarlar `.env.local` dosyasında tutulduğu için repoda açıkta kalmaz.",
  contactFormTitle: "İletişim Formu",
  contactFormEnvHint:
    "EmailJS anahtarları tanımlı değil. Formu aktifleştirmek için `.env.local` oluştur.",
  formName: "Ad Soyad",
  formNamePh: "Adınız",
  formEmail: "E-posta",
  formEmailPh: "ornek@mail.com",
  formMessage: "Mesaj",
  formMessagePh: "Kısaca ihtiyacınızı yazın…",
  formSend: "Gönder",
  formSending: "Gönderiliyor…",
  formSuccess: "Mesajınız gönderildi.",
  formError: "Gönderilemedi. Lütfen tekrar deneyin.",

  // footer
  footerNote: "Kurumsal sistemler, veri tabanı ve web üzerine notlar.",
  year: "2026",

  // resume
  resumeTitle: "CV / Resume",
  resumeDownload: "CV İndir (PDF)",
  resumePresent: "Günümüz",
  resumeSummaryTitle: "Kısa özet",
  resumeExperienceTitle: "Deneyim",
  resumeSkillsTitle: "Teknik yetkinlikler",
  resumeEducationTitle: "Eğitim",
  resumeLanguagesTitle: "Yabancı dil",
};
export default tr;
